export const createMarkup = (html: string) => ({ __html: html })
